'use strict';

angular.module('internal.services')
    .controller('InternalServiceTrainingReimbursements', ['$scope', 'ServiceUserTrainings', function ($scope, ServiceUserTrainings) {
        $scope.resetService();

        ServiceUserTrainings.get({ service_id: $scope.serviceID }).then(function (data) {
            $scope.service_user_trainings = data;
        })

        $scope.link = {
            state: 'internal.licensing.service.reimbursement',
            params: [
                {
                    name: 'reimbursementID',
                    field: 'id'
                },
                {
                    name: 'reimbursement',
                    field: ''
                }
            ]
        };

        $scope.columns = [
            {
                label: 'Personnel',
                field: 'user_nameandnumber',
                type: 'text'
            },
            {
                label: 'Course',
                field: 'training_nameandnumber',
                type: 'text'
            },
            {
                label: 'Completed On',
                field: 'training_user.completed_on',
                type: 'date',
                revertTimeZone: 'yes'
            },
            {
                label: 'Attendee Status',
                field: 'training_user.training_attendee_status_name',
                type: 'text'
            },
            {
                label: 'Reimbursement Date ',
                field: 'reimburse_date',
                type: 'date'
            },
            {
                label: 'Reimbursement Amount ',
                field: 'reimburse_amount',
                type: 'money'
            }
        ]
    }])
;